import React, { useState, useEffect, useRef, Fragment } from 'react';
import Header from '../commons/Header';
import Footer from '../commons/Footer';
import { useHistory, NavLink, Link } from "react-router-dom";
import { PROJECTNAMEALIAS, NFTAPIBASENAME, COLLECTIONIMAGEBASEURL, NFTIMAGEBASEURL } from '../helpers/Setup'
import { showToast, callAPI, showHttpError, checkIfUserIsLoggedIn, getAllSessionData, removeFromFavorite } from '../helpers/Library';
import Loader from '../commons/Loader';


const Category = (props) => {
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);
    const [showStatusCategory, setStatusCategory] = useState(false);
    const [showCurrencyCategory, setCurrencyCategory] = useState(false);
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [nftCollections, setNftCollections] = useState([]);
    const [nfts, setNfts] = useState([]);
    const [collectionCategories, setCollectionCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [categoryName, setCategoryName] = useState('');

    const [showCreateColBtn, setShowCreateColBtn] = useState(false);



    /* Method defination for get all collection by categories */
    /*  Method defination for get colletion on bassis of category id */
    let getColletionListByCategory = (categoryId) => {
        let payload = { "pageNo": pageNo, "pageSize": pageSize, "entityId": categoryId }
        setShowLoader(true)
        console.log(payload)
        setSelectedCategory(categoryId)
        callAPI('post', NFTAPIBASENAME + '/nft/market/public/getAllCollectionByCategory', payload, false).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                if (response.nftCollections != undefined && response.nftCollections != null) {
                    setNftCollections(response.nftCollections)
                } else {
                    setNftCollections([])
                 
                }
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })

    }

    






    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        setCategoryName(props.match.params.name)
        getColletionListByCategory(props.match.params.id)

    }, []);

    return (
        <Fragment>
            <Header />
            <div className="shop-box-inner">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-sm-12 col-xs-12">
                            <h3>{categoryName}</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-sm-12 col-xs-12 shop-content-right">
                            <div className="right-product-box">
                                {/* <div className="product-item-filter row"> */}
                                {/* <div className="col-12 col-sm-8 text-center text-sm-left">
                                        <div className="toolbar-sorter-right"> */}
                                {/*  <span>Sort by </span> */}
                                {/* <select id="basic" className="form-control" data-placeholder="$ USD" style={{ display: 'block' }}>
                                                <option data-display="Select">Sort By</option>
                                                <option value="1">Popularity</option>
                                                <option value="2">High Price → High Price</option>
                                                <option value="3">Low Price → High Price</option>
                                                <option value="4">Best Selling</option>
                                            </select>
                                        </div> */}
                                {/*  <p>Showing all 4 results</p> */}
                                {/* </div> */}
                                {/* <div className="col-12 col-sm-4 text-center text-sm-right"> */}
                                {/*  <ul className="nav nav-tabs ml-auto">
                                    <li>
                                        <a className="nav-link active" href="#grid-view" data-toggle="tab"> <i className="fa fa-th"></i> </a>
                                    </li>
                                    <li>
                                        <a className="nav-link" href="#list-vifew" data-toggle="tab"> <i className="fa fa-list-ul"></i> </a>
                                    </li>
                                </ul> */}
                                {/* {
                                    showCreateColBtn && 
                                    <Link to="/create-collection" className="btn btn-primary">Create Collection</Link>
                                }
                                    </div> */}
                                {/* </div> */}

                                <div className="product-categorie-box">
                                    <div className="tab-content">
                                        <div role="tabpanel" className="tab-pane fade show active" id="grid-view">
                                        <div className="row">
                                                {nftCollections.map((collection) => (
                                                    <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4" key={collection.nftCollectionId}>
                                                        <div className="products-single fix">
                                                            <Link to={`/collections/` + collection.nftCollectionId + `/` +collection.nftCollectionName} data-toggle="tooltip" data-placement="right" title="View">
                                                                <div className="box-img-hover">
                                                                    <img src={COLLECTIONIMAGEBASEURL + '/' + collection.collectionLogoName} className="img-fluid" alt="Image" style={{ width: '100%', height: '100%' }} />
                                                                </div>

                                                                <div className="why-text">
                                                                    <div className="row">
                                                                        <div className="col-md-12 col-sm-12">
                                                                            <h4>{collection.nftCollectionName}</h4>
                                                                        </div>
                                                                       
                                                                    </div>

                                                                    <p>Floor Price : {collection.floorPrice}</p>
                                                                    <p>Volume : {collection.totalVolume}</p>
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                ))}

                                                {
                                                    nftCollections.length == 0 && (
                                                        <div className="col-md-12 bg-secondary p-5">
                                                            <h1 className='text-white text-center'>No collection found</h1>
                                                            <div className='text-center mt-3'>
                                                                <a href="./create-collection" className='d-inline-block btn btn-primary'>Create Collections</a>

                                                            </div>
                                                        </div>
                                                    )
                                                }


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-xl-3 col-lg-3 col-sm-12 col-xs-12 sidebar-shop-left">
                            <div className="product-categori">
                                <div className="search-product">
                                    <form action="#">
                                        <input className="form-control" placeholder="Search here..." type="text" />
                                        <button type="submit"> <i className="fa fa-search"></i> </button>
                                    </form>
                                </div>
                                <div className="filter-sidebar-left">
                                    <div className="title-left">
                                        <h3>Categories</h3>
                                    </div>
                                    <div className="list-group list-group-collapse list-group-sm list-group-tree" id="list-group-men" data-children=".sub-men">
                                        {collectionCategories.map((cat) => (

                                            <div className="list-group-collapse sub-men" key={cat.nftCollectionCategoryId}>
                                                <a onClick={() => { getColletionListByCategory(cat.nftCollectionCategoryId) }} className={`list-group-item list-group-item-action ${cat.nftCollectionCategoryId == selectedCategory ? 'active' : ''}`} href="javascript:void(0)" >{cat.categoryName}
                                                </a>

                                            </div>
                                        ))}
                                       


                                    </div>
                                </div>
                               
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>











            <Footer />
            <Loader show={showLoader} />
        </Fragment>
    );
}

export default Category;